const moonCalcReducer = (state = {}, action) => {
  switch (action.type) {
    case 'MOON_CALC':
      if(action.data.length <= 0) return state;
      return action.data;
    default:
      return state;
  }
};
  
export default moonCalcReducer;